<template>
  <fb-main-body>
    <el-descriptions :title="$t('lang.用户信息')" :column="1">
    <el-descriptions-item labelStyle="display: none">
      <el-image
          style="width: 100px; height: 100px"
          :src="detailInfo['portrait'] | filterImg(that)" />
    </el-descriptions-item>
    <el-descriptions-item :label="$t('lang.用户编号')">{{ detailInfo['number'] }}</el-descriptions-item>
    <el-descriptions-item :label="$t('lang.账户名')">{{ detailInfo['account'] }}</el-descriptions-item>
    <el-descriptions-item :label="$t('lang.昵称')">{{ detailInfo['nickname'] }}</el-descriptions-item>
    <el-descriptions-item :label="$t('lang.性别')">{{ detailInfo['genderName'] }}</el-descriptions-item>
    <el-descriptions-item :label="$t('lang.年龄')">{{ detailInfo['age'] }}</el-descriptions-item>
    <el-descriptions-item :label="$t('lang.地区')">{{ detailInfo['areaName'] }}</el-descriptions-item>
    <el-descriptions-item :label="$t('lang.注册时间')">{{ detailInfo['registerTimeStr'] }}</el-descriptions-item>
    <el-descriptions-item :label="$t('lang.食谱收藏数')">{{ detailInfo[''] }}</el-descriptions-item>
    <el-descriptions-item :label="$t('lang.制作次数')">{{ detailInfo[''] }}</el-descriptions-item>
    <el-descriptions-item :label="$t('lang.状态')">{{$t(`lang.${detailInfo['statusName']}`)}}</el-descriptions-item>
    </el-descriptions>
  </fb-main-body>
</template>

<script>
export default {
  name: "Detail",
  data() {
    return {
      api: {
        detail: this.$api.user.detail,
      },
      detailInfo: {},
      that: this,
    }
  },
  created() {
    const vm = this;
    vm.$http.get(vm.api.detail + "?code=" + this.$route.query.code).then(res => {
      if(res.data.status != 200) {
        vm.$message.error(res.data.desc);
        return;
      }
      vm.detailInfo = res.data.data['user'];
    })
  }
}
</script>

<style scoped>

</style>
